import Joyride, { CallBackProps, Step } from 'react-joyride'
import { ReleaseTooltip } from './ReleaseTooltip'

interface ReleaseTourProps {
    steps: Step[]
    onCallback: (data: CallBackProps) => void
}

export const ReleaseTour = ({ steps, onCallback }: ReleaseTourProps) => (
    <Joyride
        run
        continuous
        steps={steps}
        tooltipComponent={ReleaseTooltip}
        styles={{
            options: { arrowColor: 'var(--numeo-accent)', overlayColor: 'rgba(0, 0, 0, 0.5)' },
            overlay: { pointerEvents: 'none' },
            overlayLegacy: { pointerEvents: 'none' },
        }}
        disableScrollParentFix
        spotlightClicks
        disableOverlayClose
        spotlightPadding={6}
        scrollToFirstStep
        showSkipButton
        callback={onCallback}
    />
)
